import React from 'react';

import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { activateLanguage } from '$/shared/frontend/utils/i18n';

activateLanguage('en');

const I18nLoader: React.FC<{ langCode?: string | null; children: React.ReactNode }> = ({
  langCode,
  children,
}) => {
  React.useEffect(() => {
    activateLanguage(langCode);
  }, [langCode]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};
export default I18nLoader;
